// eslint-disable-next-line no-restricted-syntax
export enum ShiftLogAction {
  SHIFT_OPEN = "SHIFT_OPEN",
  SHIFT_ASSIGN = "SHIFT_ASSIGN",
  SHIFT_REASSIGN = "SHIFT_REASSIGN",
  SHIFT_UNASSIGN = "SHIFT_UNASSIGN",
  SHIFT_DELETE = "SHIFT_DELETE",
  SHIFT_DELETE_FILLED = "SHIFT_DELETE_FILLED",
  FACILITY_CANCEL = "FACILITY_CANCEL",
  FACILITY_CANCEL_FILLED = "FACILITY_CANCEL_FILLED",
  FACILITY_CANCELLED_ME = "FACILITY_CANCELLED_ME",
  SHIFT_RESTORED = "SHIFT_RESTORED",
  WORKER_CANCEL = "WORKER_CANCEL",
  NO_CALL_NO_SHOW = "NO_CALL_NO_SHOW",
  SHIFT_CLAIM = "SHIFT_CLAIM",
  SHIFT_VERIFY = "SHIFT_VERIFY",
  SHIFT_PAY_RATE_CHANGE = "SHIFT_PAY_RATE_CHANGE",
  SHIFT_CHARGE_RATE_CHANGE = "SHIFT_CHARGE_RATE_CHANGE",
  SHIFT_TIME_CHANGE = "SHIFT_TIME_CHANGE",
  SHIFT_NOTE_UPDATE = "SHIFT_NOTE_UPDATE",
  AUTO_SHIFT_CHARGE_RATE_CHANGE = "AUTO_SHIFT_CHARGE_RATE_CHANGE",
  AUTO_SHIFT_PAY_RATE_CHANGE = "AUTO_SHIFT_PAY_RATE_CHANGE",
  AUTO_SHIFT_BOOST_PAY_CHANGE = "AUTO_SHIFT_BOOST_PAY_CHANGE",
  BILLABLE_ON = "BILLABLE_ON",
  BILLABLE_OFF = "BILLABLE_OFF",
  TMZ_CHANGE = "TMZ_CHANGE",
  TIMEZONE_FIX = "TIMEZONE_FIX",
  MARKED_AS_NON_URGENT = "MARKED_AS_NON_URGENT",
  WORKER_LEFT_EARLY = "WORKER_LEFT_EARLY",
  WORKER_CLOCK_IN = "WORKER_CLOCK_IN",
  WORKER_FIRST_GEOFENCE_ENTRY = "WORKER_FIRST_GEOFENCE_ENTRY",
  REPLACEMENT_SHIFT_POSTED = "REPLACEMENT_SHIFT_POSTED",
  REPLACEMENT_SHIFT_VERIFIED = "REPLACEMENT_SHIFT_VERIFIED",
  POTENTIAL_WORKER_LEFT_EARLY = "POTENTIAL_WORKER_LEFT_EARLY",
  URGENCY_UPDATED = "URGENCY_UPDATED",
  WORKPLACE_TIME_PROPOSAL_ACCEPTED = "WORKPLACE_TIME_PROPOSAL_ACCEPTED",
  WORKPLACE_TIME_PROPOSAL_DECLINED = "WORKPLACE_TIME_PROPOSAL_DECLINED",
  WORKPLACE_TIME_PROPOSAL_SENT = "WORKPLACE_TIME_PROPOSAL_SENT",
  UNASSIGNED_WORKER_GEOFENCE_ENTRY = "UNASSIGNED_WORKER_GEOFENCE_ENTRY",
  UNASSIGNED_WORKER_MOVED_TOWARDS_FACILITY = "UNASSIGNED_WORKER_MOVED_TOWARDS_FACILITY",
  MISSED_PUNCH_REQUESTED = "MISSED_PUNCH_REQUESTED",
  MISSED_PUNCH_APPROVED = "MISSED_PUNCH_APPROVED",
  MISSED_PUNCH_DECLINED = "MISSED_PUNCH_DECLINED",
  EXPECTED_ARRIVAL_TIME_ADDED = "EXPECTED_ARRIVAL_TIME_ADDED",
}

// eslint-disable-next-line no-restricted-syntax
export enum ShiftLogSubAction {
  SELF_WORKER_CANCEL = "SELF_WORKER_CANCEL",
  SELF_NO_CALL_NO_SHOW = "SELF_NO_CALL_NO_SHOW",
  CANCELLATION = "CANCELLATION",
  NO_CALL_NO_SHOW = "NO_CALL_NO_SHOW",
  FACILITY_CANCELLED_ME = "FACILITY_CANCELLED_ME",
  SHIFT_INVITE_ACCEPTED = "SHIFT_INVITE_ACCEPTED",
  SHIFT_INVITE_DECLINED = "SHIFT_INVITE_DECLINED",
  SHIFT_INVITE_EXPIRED = "SHIFT_INVITE_EXPIRED",
  EXTERNAL_VENDOR_SHIFT_CREATE = "EXTERNAL_VENDOR_SHIFT_CREATE",
  REPLACEMENT_REQUESTED = "REPLACEMENT_REQUESTED",
  WORKER_LEFT_EARLY_WITH_PERMISSION = "WORKER_LEFT_EARLY_WITH_PERMISSION",
  WORKER_LEFT_EARLY_WITHOUT_PERMISSION = "WORKER_LEFT_EARLY_WITHOUT_PERMISSION",
  BOOKING_REQUEST_ACCEPTED = "BOOKING_REQUEST_ACCEPTED",
}
